import ProjectView from "../../project-view"
import openFormAction from "../../../../../app/tools/request-forms2/actions/open-form"
import editFormAction from "../../../../../app/tools/request-forms2/actions/edit-form"
import ProjectViews from "../../project-views"
import {ProjectView_Form_AccessControl} from "./acl"
import {ProjectViewConfig} from "../../@types";
import RequestForm from "../../../form/request-form"
import ApiProject from "../../../../gd/api/project"

// const debug = "ProjectView_Form"
const debug = false

export default class ProjectView_Form extends ProjectView {

    public formId: ID // form id

    constructor(viewConfig:ProjectViewConfig, projectViews:ProjectViews) {
        super(viewConfig, projectViews)

        this.formId = viewConfig.formId!
        this.name   = _.get(viewConfig, 'name', 'Form')
    }

    get acl():ProjectView_Form_AccessControl {

        if (!this._acl) {
            this._acl = new ProjectView_Form_AccessControl(this)
        }

        return this._acl
    }

    /*open(options?: {
        isAutoOpen?: boolean
    }) {
        debug && console.log(debug, 'open', options)
        if (!options?.isAutoOpen) {
            const form = _.find(this.projectViews.project.properties.forms, form => form.id === this.id)
            debug && console.log(debug, 'open form', form)
            if (form) openFormAction(form)
        }
    }*/

    private getForm() {
        return _.find(this.projectViews.project.properties.forms, form => form.id === this.formId)
    }

    edit() {
        const form: any = this.getForm()
        if (!form) return

        form.projectId = this.projectViews.project.id
        editFormAction(new RequestForm(form))
    }

    copyUrl() {
        const form: any = this.getForm()
        if (!form) return

        const url = gdConfig.sharedViewPath + form.publicKey
        gd.utils.copyToClipboard(url)
        gd.growl.success('URL copied to clipboard.')
    }

    async rename() {
        const form: any = this.getForm()
        if (!form) return

        return new Promise((resolve, reject) => {
            gd.modals.oneInput('Name', this.name, 'Rename', async (newName)=>{
                gd.modal.hide()

                this.name = newName

                // save new project view name
                await ApiProject.updateView(this, {name:this.name}).promise()

                // save new form name
                const requestForm = new RequestForm(form)
                requestForm.name = this.name
                await requestForm.save()

                resolve(true)
            })
        })
    }

    toJson(): ProjectViewConfig {
        const res: ProjectViewConfig = super.toJson()

        res.formId = this.formId

        return res
    }
}